import React from 'react';

import {
	FrequentlyBoughtTogetherProductList,
	FrequentlyBoughtTogetherTotalPriceAddToCart
} from 'apps/frequentlyBoughtTogether/components';
import { FrequentlyBoughtTogetherProvider } from 'apps/frequentlyBoughtTogether/context';

import './AppFrequentlyBoughtTogether.scss';

type AppFrequentlyBoughtTogetherProps = {
	shortSku: string,
	products: Array<LP.product.ProductItem>
}

function AppFrequentlyBoughtTogether ({ shortSku, products }: AppFrequentlyBoughtTogetherProps) {

	return (
		<FrequentlyBoughtTogetherProvider products={products} mainShortSku={shortSku}>
			<div className="AppFrequentlyBoughtTogether">
				<FrequentlyBoughtTogetherProductList />
				<FrequentlyBoughtTogetherTotalPriceAddToCart />
			</div>
		</FrequentlyBoughtTogetherProvider>
	);

}

export default AppFrequentlyBoughtTogether;
